export interface OrderDevicesAllocatedStatsDTO {
  active                : number;
  alerting              : number;
  awaiting              : number;
  ceasedThisMonth       : number;
  nearLimit             : number;
  nearLimitThresholdUsed: number;
  newInMonth            : number;
  newToday              : number;
  overLimit             : number;
  total                 : number;
  zeroUsage             : number;
}

export function OrderDevicesAllocatedStatsDTO_EmptyObject(): OrderDevicesAllocatedStatsDTO {
  return {
    active                : 0,
    alerting              : 0,
    awaiting              : 0,
    ceasedThisMonth       : 0,
    nearLimit             : 0,
    nearLimitThresholdUsed: 80,
    newInMonth            : 0,
    newToday              : 0,
    overLimit             : 0,
    total                 : 0,
    zeroUsage             : 0
  };
}
